import SessionEvent from 'session/SessionEvent.js';
import Tone from 'tone';
import {GROUP_VOLUME_CHANGE} from 'session/constants.js';

class GroupVolumeChangeEvent extends SessionEvent {
    constructor(groupNumber, volume) {
        super();
        this.groupNumber = groupNumber;
        this.volume = volume;
    }

    executeEvent(sequencerEngine) {
        if (this.subSequence.groups.groups[this.groupNumber]) {
            this.subSequence.groups.groups[this.groupNumber].setVolume(this.volume);
        }
    }

    getType() {
        return GROUP_VOLUME_CHANGE;
    }

    getCopy() {
        return new GroupVolumeChangeEvent()
            .fromJson(this.getJson());
    }

    getJson() {
        return {
            ... super.getJson(),
            groupNumber: this.groupNumber,
            volume: this.volume
        };
    }

    fromJson(json) {
        super.fromJson(json);
        this.groupNumber = json.groupNumber;
        this.volume = json.volume;
        return this;
    }
}

export default GroupVolumeChangeEvent;
